<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-12-21 13:45:22
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-09-02 11:33:42
 * @Description:
 * @FilePath: \haozhang_pro\src\components\dialog\BuildSettings.vue
-->
<template>
  <BaseDialog
       title = "生成凭证设置"
      :showVisible = "visible"
      @close = "visible = false"
      size = "SMALL"
      @confirm = "submit"
      class="BuildSettings_dialog"
    >
    <template v-slot:content>
      <div class="radioBox">
        <el-radio-group v-model="combinationMode">
            <el-radio label="0">分开生成</el-radio>
            <el-radio label="1">相同日期合并生成，科目不合并</el-radio>
            <el-radio label="2">相同日期合并生成，科目合并</el-radio>
            <el-radio label="3">不同日期合并生成，科目不合并</el-radio>
            <el-radio label="4">不同日期合并生成，科目合并</el-radio>
        </el-radio-group>
      </div>
    </template>
    </BaseDialog>
</template>

<script>
import {saveSetting} from '@/api'
import BaseDialog from '@/components/dialog/BaseDialog.vue';
export default {
  data() {
    return {
      combinationMode:'0',
      visible: false,
      key:'',
    };
  },
  components: {
    BaseDialog,
  },
  methods: {
    openTask(key,combinationMode){
        this.key = key
        this.combinationMode = combinationMode
        this.visible = true
    },
    submit(){
      saveSetting({key:this.key,combinationMode:this.combinationMode}).then(res=>{
        if(res.data.code==1){
          this.$message.success(res.data.msg)
          this.$emit('refresh')
          this.visible = false
        }
      })
    },
    closeDialog() {
        this.key = ''
        this.combinationMode = '0'
        this.visible = false
    },
  },
};
</script>

<style lang="less" scoped>
.BuildSettings_dialog {
/deep/ .el-radio-group {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
}
.setting_title {
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  color: #333;
}
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/BuildSettings.vue